import { Injectable, inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthSession, fetchAuthSession } from 'aws-amplify/auth'
import { signInWithRedirect } from 'aws-amplify/auth'
import { from, Observable, of } from 'rxjs'
import { map, catchError } from 'rxjs/operators'

@Injectable({
    providedIn: 'root',
})
export class AuthGuardService {
    constructor(private router: Router) {}

    canActivate(): Observable<boolean> {
        return from(fetchAuthSession({ forceRefresh: true })).pipe(
            map((response: AuthSession) => {
                if (response.tokens?.idToken) {
                    return true
                } else {
                    signInWithRedirect()
                    return false
                }
            }),
            catchError(() => {
                signInWithRedirect()
                return of(false)
            })
        )
    }
}

export const AuthGuard: CanActivateFn = () => inject(AuthGuardService).canActivate()